import React, { createContext, useContext } from "react";

import { useGoldBotStatus } from "../../hooks/useGoldBotStatus";

const GoldBotStatusContext = createContext(null);

const disconnected = { data: null, error: null, isLoading: true };

/**
 * Polls /status once for the whole GoldBot page so the header indicator and
 * the Overview cards always agree about what the API just said.
 */
export function GoldBotStatusProvider({ children }) {
  const status = useGoldBotStatus();

  return (
    <GoldBotStatusContext.Provider value={status}>
      {children}
    </GoldBotStatusContext.Provider>
  );
}

export function useGoldBotStatusValue() {
  return useContext(GoldBotStatusContext) || disconnected;
}
